import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';
import Services, { ServiceProps } from '../service-options-modal/Services';

const SlideDown = require('react-slidedown').SlideDown;

interface Props {
    ceremonies: ServiceProps[];
    receptions: ServiceProps[];
    rds: ServiceProps[];
    isShown: boolean;
    onSectionExpanded?: () => void;
    onClickInquire?: () => void;
}

export interface State {
    isShown: boolean;
}

export default class ServiceOptions extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.state = {
            isShown: props.isShown,
        };
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable '>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Service Options
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && (
                            <Services
                                ceremonies={this.props.ceremonies}
                                receptions={this.props.receptions}
                                rds={this.props.rds}
                                onClickInquire={this.props.onClickInquire}
                            />
                        )}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        const trigger = !this.state.isShown;
        this.setState({ isShown: !this.state.isShown });
        if (trigger) {
            this.props.onSectionExpanded && this.props.onSectionExpanded();
        }
    }
}
